import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import LangChangeButton from "../../../languages/LangChangeButton";
import { HeaderContainer, MenuToggle } from "./styled";
import {
    Box,
    HeadingStyled,
    LazyImage,
    SpanStyled,
    SubHeadingStyled,
} from "../../styled/Elements";
import CustomDropdown from "../../common/dropdowns/CustomDropdown";
import { supportDropdownList } from "../../../helpers/adminConstants/AdminConstants";
import { LogoutIcon, Menu, ProfileImg, UserIcon, PlaceholderImg } from "../../styled/AllImages";
import AuthApi from "../../../services/api/authApi";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/authContext";
import LogoutModal from "../Modals/LogoutModal/LogoutModal";
import { useUser } from "../../../context/userContext";

const AdminHeader = ({ sidebarStatus, setSidebarStatus }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useContext(AuthContext);
    const hasLoginInLocation = location.pathname.includes("login");
    const { t } = useTranslation();
    const [isSticky, setIsSticky] = useState(false);
    const [showLogout, setShowLogout] = useState(false);
    const { user } = useUser();
    const [ profileImg, setProfileImg ] = useState();

    const onLogout = () => {
        setShowLogout(true);
    };
    useEffect(() => {
        if (user) {
            // Pre-fill form inputs with user data
            const baseAssetURL = process.env.REACT_APP_ASSET_URL;
            const profileUrl = user.profile ? `${baseAssetURL}/${user.profile}` : PlaceholderImg;
            setProfileImg(profileUrl);

        }
    }, [user]); // Dependency array to update when user or setValue changes
    const profileDropdownList = [
        {
            label: "Profile",
            icon: UserIcon,
            path: "profile",
        },
        {
            label: "Logout",
            icon: LogoutIcon,
            // path: "login",
            onClick: onLogout,
        },
    ];

    const profileDropdownTitle = () => {
        return (
            <>
                <SpanStyled className="active-dot bg-transparent position-relative border-0 p-0">
                    <LazyImage
                        width="35px"
                        height="35px"
                        src={profileImg}
                        className="rounded-circle"
                    />
                </SpanStyled>
                {/* <SubHeadingStyled color="var(--text)" size="16px" className="mx-2">
          {t("abdullah")}
        </SubHeadingStyled> */}
            </>
        );
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <>
            <HeaderContainer>
                <Box className={`header-container px-3 px-md-4`}>
                    <Box className="nav-bar justify-content-between">
                        <Box className="d-flex align-items-center gap-2">
                            <MenuToggle
                                className="border-0 px-0 bg-transparent mb-1"
                                onClick={() => setSidebarStatus(!sidebarStatus)}
                            >
                                <Menu />
                            </MenuToggle>
                            <HeadingStyled
                                size="20px"
                                weight="bold"
                                color="var(--text)"
                                className="greet-heading"
                            >
                                {t("hello")} {user?.name}!!!
                            </HeadingStyled>
                        </Box>
                        <Box className="d-flex align-items-center">
                            {/* <CustomDropdown
                                bg="var(--bgSecondary)"
                                color="var(--text)"
                                className="mx-2 support-dropdown"
                                itemsList={supportDropdownList}
                                title={t("contact_support")}
                            /> */}
                            <LangChangeButton />
                            <CustomDropdown
                                bg="var(--white)"
                                color="var(--text)"
                                className="mx-2"
                                paddingY={5}
                                paddingX={5}
                                itemsList={profileDropdownList}
                                title={profileDropdownTitle()}
                            />
                        </Box>
                    </Box>
                </Box>
                <LogoutModal
                    show={showLogout}
                    onHide={() => setShowLogout(false)}
                />
            </HeaderContainer>
        </>
    );
};

export default AdminHeader;
